import classnames from 'classnames';
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import TaskDropdownList from '@common/components/task_dropdown_list/task_dropdown_list';
import { Icon } from '@breezeway/brzw-components';
import MultipleSkeleton from '../../skeletons/multiple_skeleton';

import './recent_tasks_cell.scss';

const CLASS_NAME = 'recent-tasks-cell';

const RecentTasksCell = (props, customProps) => {
  const type = _.get(customProps, 'type');
  const tasks = _.get(props, type);
  const defaultCell = _.get(customProps, 'defaultCell');
  const withSkeletons = _.get(customProps, 'withSkeletons');
  const headerTitle = _.get(customProps, 'headerTitle');
  const isTaskInactiveByFilter = _.get(customProps, 'isTaskIncorrect');
  const containerHeight = _.get(customProps, 'containerHeight', window.innerHeight);
  const containerWidth = _.get(customProps, 'containerWidth', window.outerWidth);

  if (withSkeletons && _.isUndefined(tasks)) {
    return <MultipleSkeleton />;
  }

  if (_.isEmpty(_.keys(tasks))) {
    return <Icon iconName="history" className={`${CLASS_NAME}__trigger -empty`} />;
  }

  const renderMoreTasks = (
    <TaskDropdownList
      headerTitle={headerTitle}
      containerHeight={containerHeight}
      containerWidth={containerWidth}
      isTaskInactiveByFilter={isTaskInactiveByFilter}
      paddingVerticalRemoval={4}
      tasks={tasks}
      triggerClassName={`${CLASS_NAME}__trigger`}
      triggerText={<Icon iconName="history" />}
    />
  );

  return (
    <div className={classnames(CLASS_NAME, { 'default-cell': defaultCell })}>{renderMoreTasks}</div>
  );
};

RecentTasksCell.propTypes = {
  issues: PropTypes.arrayOf(PropTypes.shape({})), // eslint-disable-line react/no-unused-prop-types
  recent_tasks: PropTypes.arrayOf(PropTypes.shape({})), // eslint-disable-line react/no-unused-prop-types
  tasks: PropTypes.arrayOf(PropTypes.shape({})), // eslint-disable-line react/no-unused-prop-types
};

export default RecentTasksCell;
